import './App.css';
import AccessDenied from './utils/unathorised'
import PageNotFound from './utils/pagenotfound'
import AclRoute from './utils/aclRoute'
import { Route, Switch, Redirect } from 'react-router-dom';
import Sample from './components/Sample/sample';
import Dashboard from './components/DashBoard/dashboard';
import Location from './components/Location/location';
import Results from './components/Results/results';
import FlooPlanMapping from './components/FloorPlanMapping/floorPlanMapping'
import AddLocations from './components/AddLocations/addLocations'
import AddBuildings from './components/AddBuildings/addbuilding'
import AddFloors from './components/AddFloors/addfloor'
import AddRooms from './components/AddRooms/addRoom'
import TrackResults from './components/TrackResults/trackResults'
import ResultDisplay from './components/ResultDisplay/resultDisplay'
import microbiomeResults from './components/MicrobiomeResult/microbiomeResults'
import microbiomeResultsList from './components/MicrobiomeResultList/microbiomeResultsList';
import SNPDistance from './components/SNPDistance/snpDistance'
import React from 'react';
import Notification from './components/Notifications/notifications';
import SpeciesResultsComponent from './components/SpeciesResults/speciesResults';
import offlinePage from './components/networkStatus/offlinePage';
import SpeciesDashboard from './species/DashBoard/dashboard';
import SpeciesTrackResults from './species/TrackResults/trackResults';
import SpeciesFloorPlanMapping from './species/FloorPlanMapping/floorPlanMapping';
import SpeciesResultDisplay from './species/ResultDisplay/resultDisplay'
import SpeciesResults from './species/Results/results';
import SpeciesDensityResults from './species/SpeciesResults/speciesResults';
import Wiki from './components/Wiki/wiki';
import ExtLogin from './components/ExtLogin/ExtLogin'
import RegisterUser from './components/RegisterUser/registerUser'
import RiskManagementPage from './components/RiskManagement/riskManagementPage';
import ExternalUsers from './components/ExternalUsers/ExternalUsers'
import SangerAnalysis from './components/SangerAnalysis/sangerAnalysis'
import AgroAnalysis from './components/AgroAnalysis/agroAnalysis'
import AuditoriaLojas from './components/AuditoriaLojas/auditoriaLojas'

const RenderRoute = React.memo((props) => {
    return (
        <Switch>
            <AclRoute exact path="/register" component={RegisterUser} props={props} />
            <AclRoute exact path="/extlogin" component={ExtLogin} props={props}/>
            <AclRoute exact path="/dashboard" component={localStorage.getItem("species")?SpeciesDashboard:Dashboard} props={props}/>
            <AclRoute exact path="/risk-management" component={RiskManagementPage} props={props}/>
            <AclRoute exact path="/samples" component={localStorage.getItem("species")?SpeciesFloorPlanMapping:FlooPlanMapping} props={props}/>
            <AclRoute exact path="/samples/floormap" component={localStorage.getItem("species")?SpeciesFloorPlanMapping:FlooPlanMapping} props={props}/>
            <AclRoute exact path="/samples/addsamples" component={Sample} props={props}/>
            <AclRoute exact path="/manage/" component={AddBuildings} props={props}/>
            <AclRoute exact path="/manage/locations" component={Location} props={props}/>
            <AclRoute exact path="/manage/notifications" component={Notification} props={props}/>
            <AclRoute exact path="/manage/addLocations" component={AddLocations} props={props}/>
            <AclRoute exact path="/results/" component={localStorage.getItem("species")?SpeciesResultDisplay:ResultDisplay} props={props}/>
            <AclRoute exact path="/floors" component={FlooPlanMapping} props={props}/>
            <AclRoute exact path="/results/trackresults" component={localStorage.getItem("species")?SpeciesTrackResults:TrackResults} props={props}/>
            <AclRoute exact path="/results/viewresults" component={localStorage.getItem("species")?SpeciesResultDisplay:ResultDisplay} props={props}/>
            <AclRoute exact path="/results/snpresults" component={SNPDistance} props={props}/>
            <AclRoute exact path="/results/biomeresults" component={microbiomeResults} props={props}/>
            <AclRoute exact path="/results/biomeresults/grid-view" component={microbiomeResultsList} props={props}/>
            <AclRoute exact path="/results/viewresults/grid-view" component={localStorage.getItem("species")?SpeciesResults:Results} props={props}/>
            <AclRoute exact path="/results/speciesresults" component={localStorage.getItem("species")?SpeciesDensityResults:""} props={props}/>
            <AclRoute exact path="/results/speciesdensity"component={SpeciesResultsComponent} props={props}/>
            <AclRoute exact path="/manage/buildings/addBuildings" component={AddBuildings} props={props}/>
            <AclRoute exact path="/Wiki" component={Wiki} props={props}/>
            <AclRoute exact path="/manage/buildings/addFloors" component={AddFloors} props={props}/>
            <AclRoute exact path="/manage/buildings/addRooms" component={AddRooms} props={props}/>
            <Route exact path="/unathorised" component={AccessDenied} props={props}/>
            <Route exact path="/offlinePage" component={offlinePage} props={props}/>
            <Route path="/404" component={PageNotFound} props={props}/>
            <AclRoute exact path="/external-users" component={ExternalUsers} props={props}/>
            <AclRoute exact path="/sanger" component={SangerAnalysis} props={props}/>
            <AclRoute exact path="/agro" component={AgroAnalysis} props={props}/>
            <AclRoute exact path="/auditoria" component={AuditoriaLojas} props={props}/>
            <Redirect to="/404" />
        </Switch>
    );
})

export default RenderRoute;
